export const TENANT_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
};

export const TENANT_STATUS_VALUES = Object.values(TENANT_STATUS);

export const TENANT_STATUS_DEFAULT = TENANT_STATUS.ACTIVE;
